module.exports = __webpack_public_path__ + "assets/img/Concordia-Cricket-Delft.3e151fda.png";